import { defineMessages } from 'react-intl';

export default defineMessages({
    boatInformation: {
        id: 'quoteandbind.RecMarLine.views.boatTabset.Boat Information',
        defaultMessage: 'Boat Information'
    },
    additionalParts: {
        id: 'quoteandbind.RecMarLine.views.boatTabset.Additional Parts',
        defaultMessage: 'Additional Parts'
    },
    additionalInformation: {
        id: 'quoteandbind.RecMarLine.views.boatTabset.Additional Information',
        defaultMessage: 'Additional Information'
    },
    highPerformanceVesselSupplemental: {
        id: 'quoteandbind.RecMarLine.views.boatTabset.High Performance Vessel Supplemental',
        defaultMessage: 'High Performance Vessel Supplemental'
    },
    navigation: {
        id: 'quoteandbind.RecMarLine.views.boatTabset.Navigation',
        defaultMessage: 'Navigation'
    },
    extNavigation: {
        id: 'quoteandbind.RecMarLine.views.boatTabset.Extended Navigation',
        defaultMessage: 'Extended Navigation'
    },
    mooringLayup: {
        id: 'quoteandbind.RecMarLine.views.boatTabset.Mooring / Layup',
        defaultMessage: 'Mooring / Layup'
    },
    removeBoat: {
        id: 'quoteandbind.RecMarLine.views.boatTabset.Remove Boat',
        defaultMessage: 'Remove Boat',
    },
    removeBoatDesc: {
        id: 'quoteandbind.RecMarLine.views.boatTabset.riskanalysisRemovalMsg',
        defaultMessage: 'Are you sure you want to remove this Boat from the list?',
    },
    removeBoatDetails: {
        id: 'quoteandbind.RecMarLine.views.boatTabset.removeBoatDetails',
        defaultMessage: 'Boat details is removed successfully',
    },
});
